import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/app/material.module';
import { MyLibraryComponent } from './my-library.component';
// import { SummaryModalComponent } from './summary-modal/summary-modal.component';
// import { EnrollModalComponent } from './enroll-modal/enroll-modal.component';

const routes: Routes = [
    {
      path: '', component: MyLibraryComponent
    },
];

@NgModule({
  declarations: [

    // SummaryModalComponent,
    //    EnrollModalComponent
  ],
  imports: [
    RouterModule,
    ReactiveFormsModule,
    CommonModule,
    FormsModule,
    MaterialModule,
    FormsModule,
    RouterModule.forChild(routes)
  ]
})
export class MyLibraryModule { }
